import React from 'react'
import { LoginForm } from 'src/user/components'
import CreateAccountForm from 'src/dashboard/components/CreateAccountForm'
import { useSelector, useState } from 'src/hooks'
import { Dialog, Flex } from '@sendoutcards/quantum-design-ui'
import FeaturedCardsGrid from 'src/catalog/components/FeaturedCardsGrid/FeaturedCardsGrid'
import './styles.css'

interface JoinModalProps {
  onAfterSave?: () => void
  onLogin?: () => void
  onClose?: () => void
  initialAction: LoginJoinForgot
  isJoiningAffiliate?: boolean
}

export type LoginJoinForgot = 'login' | 'join' | 'forgot'

const JoinModal: React.FC<JoinModalProps> = props => {
  const { initialAction, onAfterSave, onLogin, onClose, isJoiningAffiliate } =
    props

  const [isJoining, setIsJoining] = useState(initialAction === 'join')

  const [didForgetPassword, setDidForgetPassword] = useState(false)
  const isMobile = useSelector(state => state.window.width <= 474)

  return (
    <div className={'joinModal'}>
      <Dialog
        isOpen={true}
        onClose={onClose}
        maxWidth={isMobile ? '840px' : '1040px'}
        width="100%"
      >
        <div className={'dialogContent'} id="join_modal_container">
          <div className={'formColumn'}>
            {isJoining ? (
              <CreateAccountForm
                onAfterSave={onAfterSave}
                onToggleJoinLogin={() => setIsJoining(!isJoining)}
                isAffiliateJoining={!!isJoiningAffiliate}
              />
            ) : (
              <Flex
                flexDirection="column"
                inset={{
                  horizontal: isMobile ? 'x1' : 'x3',
                  vertical: isMobile ? 'x5' : 'x3',
                }}
              >
                <LoginForm
                  title="Welcome to SendOutCards"
                  didForgetLoginInfo={didForgetPassword}
                  setForgotPassword={setDidForgetPassword}
                  onCreateAccount={() => setIsJoining(true)}
                  isAffiliateJoining={!!isJoiningAffiliate}
                  onComplete={onLogin}
                />
              </Flex>
            )}
          </div>

          <div className={'featuredCardsColumn'}>
            <FeaturedCardsGrid />
          </div>
        </div>
      </Dialog>
    </div>
  )
}

export default JoinModal
